import { apiProvider } from './api';
import Select from './components/Select.vue';
import { NAME as name } from './constants';
import { router } from './router';

export const InterniDruh = {
	name,
	apiProvider,
	router,
	components: {
		Select,
	},
};
